export default __webpack_public_path__ + "static/media/Basket.b3cf5c71.png";